// storing important variables that we might need on different places.
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/'
 // 'https://forkify-api.herokuapp.com/api/v2/recipes/49e37aeb-ebec-4984-b159-7c8b2d5137aa'
 // 'https://forkify-api.herokuapp.com/api/v2/recipes/5ed6604591c37cdc054bcc3e'
export const SPOONACULAR_API_URL = 'https://api.spoonacular.com/recipes/716429/information?apiKey=ba17f5e79da0446e81cbae506c0a9b39&includeNutrition=true'

// our developer api key to make a POST request.
export const API_KEY = 'd5ff535c-a05e-4b88-ae28-27191ee6de84'
export const SPOONACULAR_API_KEY = 'ba17f5e79da0446e81cbae506c0a9b39'
export const TIME_OUT = 10
export const RESULT_LIMIT_PER_PAGE = 10
export const WAIT_TIME_SEC = 2
